import { render, staticRenderFns } from "./SupplyHall.vue?vue&type=template&id=01b72762&scoped=true"
import script from "./SupplyHall.vue?vue&type=script&lang=js"
export * from "./SupplyHall.vue?vue&type=script&lang=js"
import style0 from "./SupplyHall.vue?vue&type=style&index=0&id=01b72762&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b72762",
  null
  
)

export default component.exports